'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TestRecorder = undefined;

var _createTest = require('./create-test');

var _createTest2 = _interopRequireDefault(_createTest);

var _testRecorder = require('./test-recorder');

var _testRecorder2 = _interopRequireDefault(_testRecorder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reduxRecord = function reduxRecord(_ref) {
  var reducer = _ref.reducer;
  var _ref$includeReducer = _ref.includeReducer;
  var includeReducer = _ref$includeReducer === undefined ? false : _ref$includeReducer;
  var stateKey = _ref.stateKey;
  var actionSubset = _ref.actionSubset;
  var _ref$equality = _ref.equality;
  var equality = _ref$equality === undefined ? '(result, nextState) => result === nextState' : _ref$equality;
  var _ref$imports = _ref.imports;
  var imports = _ref$imports === undefined ? '' : _ref$imports;
  var _ref$testLib = _ref.testLib;
  var testLib = _ref$testLib === undefined ? 'tape' : _ref$testLib;
  var _ref$numTestsToSave = _ref.numTestsToSave;
  var numTestsToSave = _ref$numTestsToSave === undefined ? 5 : _ref$numTestsToSave;

  var actions = [];
  var recording = false;
  var showingTest = false;
  var prevTests = [];
  var stringifiedReducer = '/* import reducer from YOUR_REDUCER_LOCATION_HERE */';
  if (includeReducer) {
    stringifiedReducer = 'var reducer = ' + reducer.toString();
  }
  // we can skip type checking to see if equality arg is a string since string.toString() returns same string
  var equalityFunction = equality.toString();
  var startRecord = function startRecord() {
    return recording = true;
  };
  var stopRecord = function stopRecord() {
    recording = false;
    showingTest = true;
  };
  var getRecordingStatus = function getRecordingStatus() {
    return recording;
  };
  var shouldShowTest = function shouldShowTest() {
    return showingTest;
  };
  var hideTest = function hideTest() {
    return showingTest = false;
  };
  var showTest = function showTest() {
    return showingTest = true;
  };
  var emptyActions = function emptyActions() {
    return actions = [];
  };
  var genTest = typeof testLib === 'function' ? testLib : _createTest2.default;
  if (typeof testLib !== 'string' && typeof testLib !== 'function') {
    throw new Error('testLib argument must be a string or a function');
  }
  if (typeof testLib === 'string' && !(0, _createTest.isTestLibrarySupported)(testLib)) {
    throw new Error('testLib argument does not contain a supported testing library. ' + 'Feel free to make a pr adding support or use a custom test generation function for testLib arg');
  }

  var getTest = function getTest(index) {
    if (index === null || index === undefined) {
      var test = genTest({
        actions: actions,
        imports: imports,
        equalityFunction: equalityFunction,
        reducer: stringifiedReducer,
        testLib: testLib
      });
      var testIndex = prevTests.indexOf(test);
      var isNew = testIndex === -1;
      if (isNew) {
        if (prevTests.length === numTestsToSave) {
          prevTests = prevTests.slice(1, prevTests.length);
        }
        prevTests.push(test);
        index = prevTests.length - 1;
      } else {
        index = testIndex;
      }
    }
    return prevTests[index];
  };

  var getNumTests = function getNumTests() {
    return prevTests.length;
  };

  var middleware = function middleware(_ref2) {
    var getState = _ref2.getState;
    return function (next) {
      return function (action) {
        if (recording) {
          var prevState = stateKey ? getState()[stateKey] : getState();
          next(action);
          var nextState = stateKey ? getState()[stateKey] : getState();
          if (!actionSubset || actionSubset[action.type]) {
            actions.push({ action: action, prevState: prevState, nextState: nextState });
          }
        } else {
          next(action);
        }
      };
    };
  };
  var props = {
    getRecordingStatus: getRecordingStatus,
    startRecord: startRecord,
    stopRecord: stopRecord,
    getTest: getTest,
    shouldShowTest: shouldShowTest,
    hideTest: hideTest,
    showTest: showTest,
    emptyActions: emptyActions,
    getNumTests: getNumTests
  };
  return { middleware: middleware, props: props };
};
exports.TestRecorder = _testRecorder2.default;
exports.default = reduxRecord;


/*****************
 ** WEBPACK FOOTER
 ** ./dist/index.js
 ** module id = 177
 ** module chunks = 0
 **/